<script setup lang="ts">
const router = useRouter()

// Blagues alimentaires pour la 404
const foodJokes = [
  {
    title: 'Oups! Cette page a été mangée!',
    subtitle: 'Elle était trop délicieuse pour rester ici.',
    joke: 'Pourquoi le pain est-il triste ? Parce qu\'il a perdu sa mie ! 🍞',
  },
  {
    title: 'Page introuvable!',
    subtitle: 'Elle s\'est probablement cachée dans le frigo.',
    joke: 'Qu\'est-ce qu\'un légume qui fait du karaté ? Un arti-choc ! 🥬',
  },
  {
    title: '404 - Page disparue!',
    subtitle: 'Elle a peut-être été cuisinée par erreur.',
    joke: 'Comment appelle-t-on un fromage qui rit ? Un camem-bé ! 🧀',
  },
  {
    title: 'Oups! Cette page s\'est sauvée!',
    subtitle: 'Elle a pris la clé des champs.',
    joke: 'Pourquoi la pizza est-elle ronde ? Parce qu\'elle est dans une boîte carrée ! 🍕',
  },
  {
    title: 'Page introuvable!',
    subtitle: 'Elle est peut-être partie faire l\'épicerie.',
    joke: 'Qu\'est-ce qu\'un œuf qui fait du sport ? Un œuf-sercice ! 🥚',
  },
  {
    title: '404 - Page disparue!',
    subtitle: 'Elle a peut-être été mangée par un glouton.',
    joke: 'Comment appelle-t-on un poisson qui fait du yoga ? Un poisson zen ! 🐟',
  },
]

// Sélectionner une blague aléatoire
const randomJoke = computed(() => foodJokes[Math.floor(Math.random() * foodJokes.length)])
</script>

<template>
  <main class="min-h-screen flex items-center justify-center bg-gradient-to-br from-sauge-50 to-tomate-50 p-4">
    <div class="max-w-2xl mx-auto text-center">
      <!-- Icône d'erreur thématique -->
      <div class="mb-8">
        <div class="text-8xl mb-4">
          <UIcon name="i-mdi-food-off" class="text-tomate-400" />
        </div>
        <div class="text-6xl font-bold text-poivre-800 mb-2">
          404
        </div>
      </div>

      <!-- Titre et sous-titre -->
      <h1 class="text-3xl font-bold text-poivre-800 mb-2">
        {{ randomJoke?.title }}
      </h1>
      <p class="text-lg text-poivre-600 mb-6">
        {{ randomJoke?.subtitle }}
      </p>

      <!-- Actions -->
      <div class="space-y-4">
        <UButton
          color="primary"
          size="lg"
          class="mr-4"
          icon="i-mdi-arrow-left"
          label="Retour en arrière"
          @click="router.back()"
        />

        <UButton
          :to="$localePath({ name: 'IndexPage' })"
          color="secondary"
          size="lg"
          variant="outline"
          icon="i-mdi-home"
          label="Retour à l'accueil"
        />
      </div>

      <!-- Message d'encouragement -->
      <p class="text-sm text-poivre-500 mt-8">
        Ne vous inquiétez pas, nos recettes sont toujours là! 🍳
      </p>
    </div>
  </main>
</template>

<style scoped>
/* Animation subtile pour l'icône */
.text-8xl {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
</style>
